import { searchedBioEntityElementUniProtIdSelector } from '@/redux/bioEntity/bioEntity.selectors';
import { contextMenuSelector } from '@/redux/contextMenu/contextMenu.selector';
import { closeContextMenu } from '@/redux/contextMenu/contextMenu.slice';
import { useAppDispatch } from '@/redux/hooks/useAppDispatch';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { openAddCommentModal, openMolArtModalById } from '@/redux/modal/modal.slice';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import { FIRST_ARRAY_ELEMENT, SECOND_ARRAY_ELEMENT } from '@/constants/common';

export const ContextMenu = (): React.ReactNode => {
  const dispatch = useAppDispatch();
  const { isOpen, coordinates } = useAppSelector(contextMenuSelector);
  const unitProtId = useAppSelector(searchedBioEntityElementUniProtIdSelector);

  const isUnitProtIdAvailable = (): boolean => unitProtId !== undefined;

  const getUnitProtId = (): string | undefined => {
    return isUnitProtIdAvailable() ? unitProtId : 'no UnitProt ID available';
  };

  const handleOpenMolArtClick = (): void => {
    if (isUnitProtIdAvailable()) {
      dispatch(closeContextMenu());
      dispatch(openMolArtModalById(unitProtId));
    }
  };

  const handleAddCommentClick = (): void => {
    dispatch(closeContextMenu());
    dispatch(openAddCommentModal());
  };

  return (
    <div
      className={twMerge(
        'absolute z-10 rounded-lg border border-[#DBD9D9] bg-white p-4',
        isOpen ? '' : 'hidden',
      )}
      style={{
        left: `${coordinates[FIRST_ARRAY_ELEMENT]}px`,
        top: `${coordinates[SECOND_ARRAY_ELEMENT]}px`,
      }}
      data-testid="context-modal"
    >
      <button
        className={twMerge(
          'cursor-pointer text-xs font-normal',
          !isUnitProtIdAvailable() ? 'cursor-not-allowed text-greyscale-700' : '',
        )}
        onClick={handleOpenMolArtClick}
        type="button"
        data-testid="open-molart"
      >
        Open MolArt ({getUnitProtId()})
      </button>
      <hr />
      <button
        className={twMerge('cursor-pointer text-xs font-normal')}
        onClick={handleAddCommentClick}
        type="button"
        data-testid="add-comment"
      >
        Add comment
      </button>
    </div>
  );
};
